// src/activities/cape-vr/cape-vr-views/CAPEVRRatings.jsx
// TODO Activar la creació de PDF quan hagi decidit en quines condicions
// TODO treure el botó de feeback quan hno hi ha cap mostra a avaluar

import { useTranslation } from 'react-i18next';
import { downloadCSV } from '../../../utils/cvsUtils';
import { variableTranslations } from '../../../constants/variableTranslations';
import RatingsTable from './cape-vr-files/cape-vr-ratings-files/RatingsTable';
import { detectInstrumentResponseFormat } from '../../../utils/instrumentResponsePresentation';
import { buildCapeVrNativeRatingsExportRows } from '../capeVrNativeRatingsExport';
// import { PDFDownloadLink } from '@react-pdf/renderer';
// import UserRatingsPDF from '../../../components/feedback/UserRatingsPDF';

function CAPEVRRatings({ selectedSample, submittedData, sampleDatabase, onGoToFeedback, onRestart, isSessionMode }) {
  const { t } = useTranslation();

  if (!submittedData || (!submittedData.perceptualData && !submittedData.instrumentResponse?.capeVr)) {
    return <p>{t('no_ratings_available')}</p>;
  }

  const userData = submittedData.perceptualData || {};
  const normalized = detectInstrumentResponseFormat(submittedData).kind === 'normalized';
  const normalizedExportRows = normalized
    ? buildCapeVrNativeRatingsExportRows(submittedData, t)
    : null;

  // 🔧 Processa les dades només per a exportar (no per a mostrar)
  const processedData = Object.entries(userData)
    .map(([key, value]) => {
      if (!value) return null;

      // 👉 Sempre fem servir la traducció
      const translationKey = variableTranslations[key];
      const attribute = t(
        translationKey || key,
        { defaultValue: translationKey || key } // fallback
      );

      const userRating =
        value.VASValue !== undefined && value.VASValue !== null
          ? `${value.VASValue}/100`
          : value.isPresent
          ? t('yes')
          : '-';

      const userComment = value.attributeComment ?? '-';

      if (key === 'overallImpression') return null;

      return {
        [t('attribute')]: attribute,
        [t('rating')]: userRating,
        [t('comment')]: userComment
      };
    })
    .filter(Boolean);

  if (userData.overallImpression) {
    const overallKey =
      variableTranslations['overallImpression'] || 'overall_impression';
    processedData.push({
      [t('attribute')]: t(overallKey, { defaultValue: overallKey }),
      [t('rating')]: '-',
      [t('comment')]: userData.overallImpression
    });
  }

  // 📋 Copia al porta-retalls
  const handleCopyToClipboard = () => {
    if (normalizedExportRows) {
      const header = `${t('attribute')},${t('rating')},${t('comment')}`;
      const csvContent = normalizedExportRows
        .map(row => `${row.attribute},${row.rating},${row.comment}`)
        .join('\n');
      navigator.clipboard.writeText(`${header}\n${csvContent}`);
      alert(t('copied_to_clipboard'));
      return;
    }
    const header = `${t('attribute')},${t('rating')},${t('comment')}`;
    const csvContent = processedData
      .map(
        (row) =>
          `${row[t('attribute')]},${row[t('rating')]},${row[t('comment')]}`
      )
      .join('\n');
    navigator.clipboard.writeText(`${header}\n${csvContent}`);
    alert(t('copied_to_clipboard'));
  };

  // 💾 Descarrega CSV
  const handleDownloadCSV = () => {
    const filename = `${t('ratings')}.csv`;
    if (normalizedExportRows) {
      downloadCSV(normalizedExportRows.map(row => ({
        [t('attribute')]: row.attribute,
        [t('rating')]: row.rating,
        [t('comment')]: row.comment,
      })), filename);
      return;
    }
    downloadCSV(processedData, filename, [
      t('attribute'),
      t('rating'),
      t('comment')
    ]);
  };

  return (
    <div className="ratings-report">
      <h2>{t('your_ratings')}</h2>

      {/* 🔹 Botons d'exportació */}
      <div className="app-btn-container">
        <button onClick={handleCopyToClipboard} className="app-btn app-btn-primary">
          {t('copy_ratings_to_clipboard')}
        </button>
        <button onClick={handleDownloadCSV} className="app-btn app-btn-primary">
          {t('download_ratings_in_csv_format')}
        </button>
        {/* <PDFDownloadLink
          document={<UserRatingsPDF data={processedData} />}
          fileName="user_ratings.pdf"
          className="app-btn app-btn-primary"
        >
          {({ loading }) => (loading ? t('generating_pdf') : t('download_pdf'))}
        </PDFDownloadLink> */}
      </div>

      {/* 🔥 Taules agrupades */}
      <RatingsTable submittedData={submittedData} />

      {/* 🔗 Botons finals segons base de dades i mode */}
      <div className="app-btn-container">
        {/* 🔹 Només mostra el botó si la mostra NO és pujada NI placeholder */}
        {!selectedSample?.identificationData?.isUpload &&
        !selectedSample?.identificationData?.isPlaceholder &&
        !isSessionMode && (
          <button onClick={onGoToFeedback} className="app-btn app-btn-primary">
            {t('view_feedback')}
          </button>
        )}
      </div>
    </div>
  );
}

export default CAPEVRRatings;
